import React from "react";

import hidePasswordIcon from "../images/icon-hide-password.svg";

import Input from "./Input";

class PasswordInput extends React.Component {
  state = {
    isVisible: false,
  };

  render() {
    return (
      <div className="password-field">
        <Input
          {...this.props}
          type={this.state.isVisible ? "text" : "password"}
        />
        <img
          className="hide-password-icon"
          src={hidePasswordIcon}
          alt="hide-password-icon"
          onClick={() => {
            this.setState({ isVisible: !this.state.isVisible });
          }}
        />
      </div>
    );
  }
}

export default PasswordInput;
